import React, { useCallback, useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export const TrainingGalleryStrip = () => {
  const galleryItems = ['https://uploadthingy.s3.us-west-1.amazonaws.com/fUrvThWdJVSVsYbHQSSyQ8/SAV_8518.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/62DL8VzUWoZSsys88qcCmf/speaking_anne.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9ciCFjhcNKhhvWPuNF4wxL/Network_Scoot.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mStosbmgsDJZaVNXWK79Vp/IMG-20241230-WA0235.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/vqYAu12xeCB8m1eJ25tfZh/SAV_8332.jpg'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  // Handle responsive visible count
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setVisibleCount(1);else if (window.innerWidth < 1024) setVisibleCount(2);else setVisibleCount(3);
    };
    // Initial check
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const maxIndex = Math.max(0, galleryItems.length - visibleCount);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prev => prev >= maxIndex ? 0 : prev + 1);
  }, [maxIndex]);
  const prevSlide = () => {
    setCurrentIndex(prev => prev <= 0 ? maxIndex : prev - 1);
  };
  // Auto-play interval
  useEffect(() => {
    const timer = setInterval(nextSlide, 4000);
    return () => clearInterval(timer);
  }, [nextSlide]);
  return <section className="py-16 bg-white border-b border-gray-100 overflow-hidden" data-id="element-1235" data-mp="r40kr0oyclmj">
      <div className="container mx-auto px-4 mb-10" data-id="element-1236" data-mp="m5z04bbvoe8y">
        <div className="text-center scroll-animate" data-id="element-1237" data-mp="m5gzz3m3hfvr">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-3 font-heading" data-id="element-1238" data-mp="3bvkcc4qrwt88">
            Training and Networking in Action
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1239" data-mp="36umtdpxxvv5o">
            See our hands-on sessions across Nigeria
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 relative scroll-animate" style={{
      animationDelay: '200ms'
    }} data-id="element-1240" data-mp="3dcg8sh7tbkv8">
        <div className="relative overflow-hidden group" data-id="element-1241" data-mp="2zej8pau5gwbt">
          {/* Slider Track */}
          <div className="flex transition-transform duration-500 ease-in-out" style={{
          transform: `translateX(-${currentIndex * (100 / visibleCount)}%)`
        }} data-id="element-1242" data-mp="349ovsczagh1h">
            {galleryItems.map((image, index) => <div key={index} className="flex-shrink-0 px-3" style={{
            width: `${100 / visibleCount}%`
          }} data-id="element-1243" data-mp="2gn8kx2jq0zo5" data-mpi={index}>
                <div className="relative h-[320px] md:h-[400px] rounded-xl overflow-hidden shadow-md" data-id="element-1244" data-mp="26p2j0kxwztja">
                  <img src={image} alt={`Training session ${index + 1}`} className="absolute inset-0 w-full h-full object-cover" data-id="element-1245" data-mp="2bmb52wm6ohpt" />
                </div>
              </div>)}
          </div>

          {/* Navigation Arrows */}
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -ml-2 md:ml-2 bg-white/90 hover:bg-white text-navy p-2 rounded-full shadow-lg transition-all z-10 opacity-0 group-hover:opacity-100 disabled:opacity-0" disabled={currentIndex === 0} aria-label="Previous image" data-id="element-1246" data-mp="220jk8xdqggg6">
            <ChevronLeft size={24} data-id="element-1247" data-mp="2koolny6x3pbt" />
          </button>
          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 -mr-2 md:mr-2 bg-white/90 hover:bg-white text-navy p-2 rounded-full shadow-lg transition-all z-10 opacity-0 group-hover:opacity-100 disabled:opacity-0" disabled={currentIndex === maxIndex} aria-label="Next image" data-id="element-1248" data-mp="2krkj7leusbzq">
            <ChevronRight size={24} data-id="element-1249" data-mp="n1mf6y067oes" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8" data-id="element-1250" data-mp="rzxo96in5uvy">
          {Array.from({
          length: maxIndex + 1
        }).map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentIndex === idx ? 'bg-navy w-6' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to slide group ${idx + 1}`} data-id="element-1251" data-mp="11r22u54endq9" data-mpi={idx} />)}
        </div>
      </div>
    </section>;
};